import { render, staticRenderFns } from "./CourseIndexAdd.vue?vue&type=template&id=7129e346&scoped=true"
import script from "./CourseIndexAdd.vue?vue&type=script&lang=js"
export * from "./CourseIndexAdd.vue?vue&type=script&lang=js"
import style0 from "./CourseIndexAdd.vue?vue&type=style&index=0&id=7129e346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7129e346",
  null
  
)

export default component.exports